<template>
  <div class="breadcrumbs-section critical-component-clear">
    <breadcrumbs
      :collection-title="previousPageName"
      :collection-url="previousUrl"
      :name="pageTitle"
      state="ready"
    />
  </div>
</template>

<script>

import { capitalize } from '~/helpers/general'

/**
 * Vue: Breadcrumbs section (breadcrumbs-section)
 * -----------------------------------------------------------------------------
 * Customizable breadcrumbs.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'BreadcrumbsSection',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        settings: {},
      }),
    },
  },

  data() {
    return {

    }
  },

  computed: {
    pageTitle() {
      const title = this.liquid.settings.breadcrumbs_current_title
      return title ? title : this.$variable('page.title')
    },

    previousPageName() {
      const customTitle = this.liquid.settings.breadcrumbs_prev_title
      const title = this.liquid.settings.breadcrumbs_prev_url?.split('/').pop()
      if (customTitle) {
        return customTitle
      }
      return title ? capitalize(title.replaceAll('-', ' ')) : ''
    },

    previousUrl() {
      return this.liquid.settings.breadcrumbs_prev_url || ''
    },

  },
}
</script>

<style lang="scss">
@import './breadcrumbs-section';
</style>
